/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SocialTwitter.vue?vue&type=template&id=4a94b7d5&"
import script from "./SocialTwitter.vue?vue&type=script&lang=js&"
export * from "./SocialTwitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports